export default __webpack_public_path__ + "1697e0b3705a7e8671e70440db6010f7.webp";